package org.example.project.game

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.database.database
import kotlinx.coroutines.flow.first

class LevelRepository {
    private val db = Firebase.database("https://assoziation-c5cda-default-rtdb.firebaseio.com")
    private val gamesRef = db.reference("games")

    suspend fun fetchRandomLevel(requestedLang: String, difficulty: String): Pair<String, LangPack> {
        val targetLang = requestedLang.uppercase().trim()
        val snapshot = gamesRef.valueEvents.first()

        val allLevels = snapshot.children.mapNotNull { child ->
            val level = child.value(FirebaseLevel.serializer())
            val id = child.key
            if (id != null && level != null) id to level else null
        }

        val exactMatches = allLevels.filter { (_, level) ->
            level.translations.containsKey(targetLang) && level.difficulty == difficulty
        }

        val safePool = exactMatches.ifEmpty {
            allLevels.filter { (_, level) -> level.translations.containsKey(targetLang) }
        }

        if (safePool.isEmpty()) throw Exception("Kein Level für $targetLang gefunden!")

        val (levelId, levelData) = safePool.random()
        return levelId to levelData.translations[targetLang]!!
    }
}